import FastFiveQuestionnaire from './questionnaire';
export default FastFiveQuestionnaire;